export * from './icon.service';
export * from './icon-service.injection-token';
